export default function InputLabel({ label, children, position = "side" }) {
  return (
    <div className={` ${position !== "top" && "flex"} items-center w-full`}>
      <label className="text-xs pr-2 ">{label}:</label>
      <div className={`${position == "top" && "w-full"}`}>{children}</div>
    </div>
  );
}
